<template>
  <modal :is-opaque="false" :smaller="true" name="remote-invite">
    <h3>Invite Customers To View</h3>

    <crud-errors :errors="errors"></crud-errors>

    <dl>
      <dt>Email Address</dt>
      <dd><input v-model="email" name="remote_invite_email" placeholder="Enter email address of customer" type="email"/>
      </dd>
      <dt>CC Email Addresses</dt>
      <dd><input v-model="cc" name="remote_invite_email_cc" placeholder="Enter email address of other people to invite"
                 type="text"/></dd>
      <dt>Email Subject</dt>
      <dd><input v-model="subject" name="subject" placeholder="Email Subject" type="text"/></dd>
      <dt>Message</dt>
      <dd>
        <textarea style="height: 200px;" v-model="body" placeholder="Email Message"></textarea>
        <small>Note, %WEBLINK% will be replaced with a link the user can click on to view the estimate.</small>
      </dd>
    </dl>

    <div class="actions">
      <a href="#" @click.prevent="closeModal()">Cancel</a>
      <a class="success" href="#" @click.prevent="sendInvitation()">Send Invite</a>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      required: false,
      default: '#'
    }
  },
  data() {
    return {
      email: "",
      cc: "",
      subject: "",
      body: "",
      type: "",
      typeId: null,
      copy_me_in: false,
      errors: null
    }
  },
  methods: {
    closeModal() {
      this.resetData();
      eventBus.$emit('modal-close-remote-invite');
    },
    openModal(){
      eventBus.$emit('modal-open-remote-invite');
    },
    resetData() {
      this.email = '';
      this.cc = '';
      this.subject = '';
      this.body = '';
      this.type = '';
      this.typeId = null;
      this.errors = null;
    },
    sendInvitation() {
      let that = this;
      let email = this.email;
      let cc = this.cc.replace(',',' ').split(' ');

      axios.request({
        method: 'post',
        url: appUrls.remotev2.create,
        data: {
          email: this.email,
          cc: cc,
          subject: this.subject,
          body: this.body,
          type: this.type,
          typeId: this.typeId
        },
        config: {}
      }).then(response => {
        that.closeModal();
        eventBus.$emit('remote-invites-updated');

      }).catch(function (error) {
        if (error.response.status === 422) {
          that.errors = error.response.data.errors;
        }
      });
    },

  },
  mounted() {
    let that = this;

    eventBus.$on('open-remote-invites', function (subject, type, typeId) {
      that.resetData();
      that.subject = subject;
      that.type = type;
      that.typeId = typeId;
      that.body = "Please click on the following link to view the estimate.\n" +
          "\n" +
          "%WEBLINK%\n" +
          "\n" +
          "This link will be valid for 30 days.\n" +
          "\n" +
          "Kind regards,\n" +
          "\n" + appData.user.name;

      that.openModal();
    });
  }
}
</script>

<style lang="scss" scoped>

</style>
